import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RentalsService } from '../../../../../services/rentals.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { PaymentService } from '../../../../../services/payment.service';

@Component({
  selector: 'app-rental-affiliates',
  templateUrl: './rental-affiliates.component.html',
  styleUrls: ['./rental-affiliates.component.scss'],
})
export class RentalAffiliatesComponent implements OnInit {
  public loadingAffiliates: boolean = false;
  public affiliates: any = [];
  public showAffiliate: boolean = false;
  public selectedAffiliate: any = null;
  public hasStripeConfigured: boolean = false;

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private paymentService: PaymentService,
  ) {}

  ngOnInit() {
    this.getAffiliates();
    this.checkIfLinkedToStripeConnect();
  }

  getAffiliates() {
    this.loadingAffiliates = true;
    this.rentalsService
      .getRentalAffiliates(this.helpersService.getPartnerId())
      .subscribe(
        (affiliates: any) => {
          this.affiliates = affiliates;
          this.loadingAffiliates = false;
        },
        (err) => {
          this.loadingAffiliates = false;
        },
      );
  }

  checkIfLinkedToStripeConnect() {
    this.paymentService
      .checkPartnerLinkedStripeConnect(this.helpersService.getPartnerId())
      .subscribe(
        (result) => {
          this.hasStripeConfigured = result.linked;
        },
        (error) => {},
      );
  }

  openAffiliate(affiliate) {
    this.selectedAffiliate = affiliate;
    this.showAffiliate = true;
  }

  addNewAffiliate() {
    this.selectedAffiliate = {};
    this.showAffiliate = true;
  }

  closePanel(event) {
    this.selectedAffiliate = {};
    this.showAffiliate = false;
  }
}
